<h1>Nyugdíjazott kutyák</h1>

<app-doglist [fullDogList]="retiredDogs"></app-doglist>
